if (!customElements.get('lazy-video')) {
  // Videos load only when near the viewport and pause when they leave it; a horizontally clipped
  // slider slide counts as out of view, so only visible slides play.
  const observer = new IntersectionObserver(
    (entries) => {
      for (const { target, isIntersecting } of entries) target.closest('lazy-video')?.toggle(isIntersecting);
    },
    { rootMargin: '200px' }
  );

  customElements.define(
    'lazy-video',
    class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (this.video) observer.observe(this.video);
      }

      disconnectedCallback() {
        if (this.video) observer.unobserve(this.video);
      }

      toggle(visible) {
        const { poster } = this.video.dataset;
        if (visible && poster && !this.video.poster) this.video.poster = poster;
        if (visible) this.play();
        else this.video.pause();
      }

      play() {
        const { video } = this;
        if (!video.getAttribute('src')) {
          const { srcSmall, srcLarge } = video.dataset;
          const large = window.matchMedia('(min-width: 768px)').matches;
          video.src = (large ? srcLarge : srcSmall) || srcLarge || srcSmall;
        }
        video.play()?.catch(() => {});
      }
    }
  );
}
